"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2892],{

/***/ 73863:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/RecipeArrow.aa0a3960.svg","height":16,"width":16});

/***/ }),

/***/ 26063:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Attom.db123901.svg","height":60,"width":60});

/***/ }),

/***/ 32863:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/DataAxle.5969596e.svg","height":36,"width":46});

/***/ }),

/***/ 59097:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ industryPages; }
});

// EXTERNAL MODULE: ./src/constants/linksConstants.js
var linksConstants = __webpack_require__(71571);
;// CONCATENATED MODULE: ./src/landingPage/assets/svg/Industry/FinancialGroup-1_horizontal.svg
/* harmony default export */ var FinancialGroup_1_horizontal = ({"src":"/_next/static/media/FinancialGroup-1_horizontal.6d194df4.svg","height":210,"width":1066});
;// CONCATENATED MODULE: ./src/landingPage/assets/svg/Industry/FinancialGroup-2_horizontal.svg
/* harmony default export */ var FinancialGroup_2_horizontal = ({"src":"/_next/static/media/FinancialGroup-2_horizontal.2de27084.svg","height":162,"width":1066});
;// CONCATENATED MODULE: ./src/landingPage/assets/svg/Industry/FinancialGroup-1_vertical.svg
/* harmony default export */ var FinancialGroup_1_vertical = ({"src":"/_next/static/media/FinancialGroup-1_vertical.58723777.svg","height":534,"width":87});
;// CONCATENATED MODULE: ./src/landingPage/assets/svg/Industry/FinancialGroup-2_vertical.svg
/* harmony default export */ var FinancialGroup_2_vertical = ({"src":"/_next/static/media/FinancialGroup-2_vertical.bfba1ea3.svg","height":534,"width":82});
;// CONCATENATED MODULE: ./src/landingPage/assets/svg/Industry/InsuranceGroup-1_horizontal.svg
/* harmony default export */ var InsuranceGroup_1_horizontal = ({"src":"/_next/static/media/InsuranceGroup-1_horizontal.82ca7dee.svg","height":162,"width":1066});
;// CONCATENATED MODULE: ./src/landingPage/assets/svg/Industry/InsuranceGroup-2_horizontal.svg
/* harmony default export */ var InsuranceGroup_2_horizontal = ({"src":"/_next/static/media/InsuranceGroup-2_horizontal.16b4a424.svg","height":210,"width":1066});
;// CONCATENATED MODULE: ./src/landingPage/assets/svg/Industry/InsuranceGroup-3_horizontal.svg
/* harmony default export */ var InsuranceGroup_3_horizontal = ({"src":"/_next/static/media/InsuranceGroup-3_horizontal.6d84af1c.svg","height":162,"width":1066});
;// CONCATENATED MODULE: ./src/landingPage/assets/svg/Industry/InsuranceGroup-1_vertical.svg
/* harmony default export */ var InsuranceGroup_1_vertical = ({"src":"/_next/static/media/InsuranceGroup-1_vertical.b82f8aaa.svg","height":534,"width":82});
;// CONCATENATED MODULE: ./src/landingPage/assets/svg/Industry/InsuranceGroup-2_vertical.svg
/* harmony default export */ var InsuranceGroup_2_vertical = ({"src":"/_next/static/media/InsuranceGroup-2_vertical.4cf279ae.svg","height":534,"width":87});
;// CONCATENATED MODULE: ./src/landingPage/assets/svg/Industry/InsuranceGroup-3_vertical.svg
/* harmony default export */ var InsuranceGroup_3_vertical = ({"src":"/_next/static/media/InsuranceGroup-3_vertical.78522d72.svg","height":534,"width":82});
// EXTERNAL MODULE: ./src/landingPage/views/assets/logos/Anz.svg
var Anz = __webpack_require__(33911);
// EXTERNAL MODULE: ./src/landingPage/views/assets/logos/StandardChartered.svg
var StandardChartered = __webpack_require__(86051);
// EXTERNAL MODULE: ./src/landingPage/views/assets/logos/Clearco.svg
var Clearco = __webpack_require__(8869);
// EXTERNAL MODULE: ./src/landingPage/views/assets/logos/Farmers.svg
var Farmers = __webpack_require__(59874);
// EXTERNAL MODULE: ./src/landingPage/views/assets/logos/Openly.svg
var Openly = __webpack_require__(68197);
;// CONCATENATED MODULE: ./src/landingPage/views/assets/logos/OpenCorporates.svg
/* harmony default export */ var OpenCorporates = ({"src":"/_next/static/media/OpenCorporates.598e65c0.svg","height":80,"width":80});
;// CONCATENATED MODULE: ./src/landingPage/views/assets/logos/Experian.svg
/* harmony default export */ var Experian = ({"src":"/_next/static/media/Experian.fd589235.svg","height":80,"width":80});
;// CONCATENATED MODULE: ./src/landingPage/views/assets/logos/Equifax_1.svg
/* harmony default export */ var Equifax_1 = ({"src":"/_next/static/media/Equifax_1.d9a973b0.svg","height":80,"width":80});
;// CONCATENATED MODULE: ./src/landingPage/views/assets/logos/Sayari.svg
/* harmony default export */ var Sayari = ({"src":"/_next/static/media/Sayari.e856fce8.svg","height":80,"width":80});
;// CONCATENATED MODULE: ./src/landingPage/views/assets/logos/Seon_1.svg
/* harmony default export */ var Seon_1 = ({"src":"/_next/static/media/Seon_1.8a2bfd76.svg","height":80,"width":80});
;// CONCATENATED MODULE: ./src/landingPage/views/assets/logos/Ekata_1.svg
/* harmony default export */ var Ekata_1 = ({"src":"/_next/static/media/Ekata_1.d1afc241.svg","height":80,"width":80});
;// CONCATENATED MODULE: ./src/landingPage/views/assets/logos/Nomino.svg
/* harmony default export */ var Nomino = ({"src":"/_next/static/media/Nomino.2afb5998.svg","height":80,"width":80});
;// CONCATENATED MODULE: ./src/landingPage/views/assets/logos/Acxiom.svg
/* harmony default export */ var Acxiom = ({"src":"/_next/static/media/Acxiom.c1704960.svg","height":80,"width":80});
// EXTERNAL MODULE: ./src/landingPage/views/assets/logos/Attom.svg
var Attom = __webpack_require__(26063);
;// CONCATENATED MODULE: ./src/landingPage/views/assets/logos/HazardHub.svg
/* harmony default export */ var HazardHub = ({"src":"/_next/static/media/HazardHub.3367dae3.svg","height":80,"width":80});
// EXTERNAL MODULE: ./src/landingPage/views/assets/logos/DataAxle.svg
var DataAxle = __webpack_require__(32863);
;// CONCATENATED MODULE: ./src/landingPage/views/assets/logos/Infutor.svg
/* harmony default export */ var Infutor = ({"src":"/_next/static/media/Infutor.ed8f45ef.svg","height":80,"width":80});
;// CONCATENATED MODULE: ./src/landingPage/views/assets/logos/PeopleDataLabs.svg
/* harmony default export */ var PeopleDataLabs = ({"src":"/_next/static/media/PeopleDataLabs.d33464a5.svg","height":80,"width":80});
// EXTERNAL MODULE: ./src/landingPage/assets/card-check.svg
var card_check = __webpack_require__(68837);
;// CONCATENATED MODULE: ./src/landingPage/datasets/industryPages.js

/* Hero Images */ // Financial Services




// Insurance






// Footer





/* Data Providers Images */ 













var data = {
    hero: {
        financialServices: {
            title: "Optimize your external data spend with a single platform",
            description: "Rapidly deploy the right external data solutions for financial services.",
            images: {
                mainSection: [
                    {
                        id: 1,
                        img: {
                            desktop: FinancialGroup_1_horizontal,
                            mobile: FinancialGroup_1_vertical
                        },
                        alt: "group of icons 1"
                    },
                    {
                        id: 2,
                        img: {
                            desktop: FinancialGroup_2_horizontal,
                            mobile: FinancialGroup_2_vertical
                        },
                        alt: "group of icons 2"
                    }, 
                ],
                footerSection: [
                    {
                        id: 1,
                        img: Anz/* default */.Z,
                        alt: "ANZ",
                        width: "96",
                        height: "31"
                    },
                    {
                        id: 2,
                        img: StandardChartered/* default */.Z,
                        alt: "Standart Chartered",
                        width: "111",
                        height: "45"
                    },
                    {
                        id: 3,
                        img: Clearco/* default */.Z,
                        alt: "Clearco",
                        width: "119",
                        height: "25"
                    }, 
                ]
            }
        },
        insurance: {
            title: "Optimize your external data spend with a single platform",
            description: "Rapidly deploy the right external data solutions for insurance.",
            images: {
                mainSection: [
                    {
                        id: 1,
                        img: {
                            desktop: InsuranceGroup_1_horizontal,
                            mobile: InsuranceGroup_1_vertical
                        },
                        alt: "group of icons 1"
                    },
                    {
                        id: 2,
                        img: {
                            desktop: InsuranceGroup_2_horizontal,
                            mobile: InsuranceGroup_2_vertical
                        },
                        alt: "group of icons 2"
                    },
                    {
                        id: 3,
                        img: {
                            desktop: InsuranceGroup_3_horizontal,
                            mobile: InsuranceGroup_3_vertical
                        },
                        alt: "group of icons 3"
                    }, 
                ],
                footerSection: [
                    {
                        id: 1,
                        img: Farmers/* default */.Z,
                        alt: "Farmers",
                        width: "82",
                        height: "44"
                    },
                    {
                        id: 2,
                        img: Openly/* default */.Z,
                        alt: "Openly",
                        width: "71",
                        height: "45"
                    }, 
                ]
            }
        }
    },
    textSection: {
        financialServices: [
            {
                title: "Attract the right customers",
                text1: "Focus targeting on demographics aligned with your strategy",
                text2: "Confidently identify, enrich, and prioritize the right marketing leads",
                img: card_check/* default.src */.Z.src
            },
            {
                title: "Frictionless onboarding and verification",
                text1: "Onboard customers seamlessly in seconds",
                text2: "Verify customers globally with a single platform",
                img: card_check/* default.src */.Z.src
            },
            {
                title: "Maintain and retain customers",
                text1: "Customer 360 for cross-sell, up-sell & retention optimization",
                text2: "Regularly diligence your customer portfolio",
                img: card_check/* default.src */.Z.src
            }, 
        ],
        insurance: [
            {
                title: "Expand customer lifetime value",
                text1: "Customer 360 for cross-sell, up-sell & retention optimization",
                text2: "Confidently identify, enrich, and prioritize the right marketing leads",
                img: card_check/* default.src */.Z.src
            },
            {
                title: "Reduce application drop-off",
                text1: "Prefill auto, property and business details for rapid onboarding",
                text2: "Gather a more extensive set of data for underwriting",
                img: card_check/* default.src */.Z.src
            },
            {
                title: "Optimise your claims processes",
                text1: "Verify and validate the identity of the claimant",
                text2: "Enrich customer contact details to improve contactability",
                img: card_check/* default.src */.Z.src
            }, 
        ]
    },
    metrics: {
        financialServices: [
            {
                label: "12x",
                description: "Reduce fraud false positives by up to"
            },
            {
                label: "1",
                description: "Platform for all your use cases"
            },
            {
                label: "97%",
                description: "Accelerate customer onboarding by up to"
            }, 
        ],
        insurance: [
            {
                label: "32,000",
                description: "Additional high churn risk customers identified for a leading Insurer"
            },
            {
                label: "1",
                description: "Platform for all your use cases"
            },
            {
                label: "87%",
                description: "Of US customer profiles enriched for a global insurtech"
            }, 
        ]
    },
    recipes: {
        financialServices: [
            {
                title: "Business Firmographics for US KYB, Onboarding and Marketing",
                description: "Use this recipe to retrieve US firmographics ...",
                url: "/app/recipe/2/business-firmographics-for-us-kyb-onboarding-and-marketing",
                type: "BUSINESS",
                ctaText: "Access Recipe"
            },
            {
                title: "Business Registration and UBO for US KYB",
                description: "Use this recipe as part of a know-your-business (KYB) workflow in the US to gather key ...",
                url: "/app/recipe/37/business-registration-and-ubo-for-us-kyb",
                type: "BUSINESS",
                ctaText: "Access Recipe"
            },
            {
                title: "Business Registration and Linked Company Details for Global KYB",
                description: "Use this recipe as part of a know-your-business ...",
                url: "/app/recipe/65/business-registration-and-linked-company-details-for-global-kyb",
                type: "BUSINESS",
                ctaText: "Access Recipe"
            },
            {
                title: "Business Customer Onboarding",
                description: "Use this recipe to make an assessment about the risk of onboarding a new business customer ...",
                url: "/app/recipe/54/business-customer-onboarding",
                type: "BUSINESS",
                ctaText: "Access Recipe"
            },
            {
                title: "Email Address and Phone Number Fraud Risk Signals",
                description: "Use this recipe as part of a Know-Your-Customer (KYC) process to identify email addresses and ...",
                url: "/app/recipe/11/email-address-and-phone-number-fraud-risk-signals",
                type: "BUSINESS",
                ctaText: "Access Recipe"
            },
            {
                title: "Person Homeowner Status for Prefill and Marketing",
                description: "Use this recipe to determine whether an individual rents or owns a specific property.",
                url: "/app/recipe/13/person-homeowner-status-for-prefill-and-marketing",
                type: "BUSINESS",
                ctaText: "Access Recipe"
            }, 
        ],
        insurance: [
            {
                title: "Property Prefill",
                description: "Use this recipe to prefill US property information for new residential or commercial property ...",
                url: "/app/recipe/21/property-prefill",
                type: "API",
                ctaText: "Access Recipe"
            },
            {
                title: "Business Prefill",
                description: "Use this recipe as part of a know-your-business (KYB) workflow in the US to gather key ...",
                url: "/app/recipe/32/business-prefill",
                type: "API",
                ctaText: "Access Recipe"
            },
            {
                title: "Auto Prefill From Person Identifier",
                description: "Use this recipe to prefill US vehicle information ...",
                url: "/app/recipe/28/auto-prefill-from-person-identifier",
                type: "API",
                ctaText: "Access Recipe"
            },
            {
                title: "Auto Prefill From Vehicle Identifier",
                description: "Use this recipe to prefill US vehicle information associated with a VIN number for auto ...",
                url: "/app/recipe/28/auto-prefill-from-person-identifier",
                type: "API",
                ctaText: "Access Recipe"
            },
            {
                title: "Business and Property Prefill",
                description: "Use this recipe to prefill information for US business lines or commercial property insurance ...",
                url: "/app/recipe/11/email-address-and-phone-number-fraud-risk-signals",
                type: "API",
                ctaText: "Access Recipe"
            },
            {
                title: "Automotive and Property Insurance Churn Indicators",
                description: "You can use this recipe to identify any indicators of churn risk in your automotive and property ...",
                url: "/app/recipe/51/automotive-and-property-insurance-churn-indicators",
                type: "API",
                ctaText: "Access Recipe"
            }, 
        ]
    },
    dataProviders: {
        financialServices: [
            {
                img: OpenCorporates,
                name: "Opencorporates",
                url: "".concat(linksConstants/* linksConstants.DATA_CATALOG_CONNECTORS */.s.DATA_CATALOG_CONNECTORS, "?data_source=OpenCorporates")
            },
            {
                img: Experian,
                name: "Experian",
                url: "".concat(linksConstants/* linksConstants.DATA_CATALOG_CONNECTORS */.s.DATA_CATALOG_CONNECTORS, "?data_source=Experian")
            },
            {
                img: Equifax_1,
                name: "Equifax",
                url: "".concat(linksConstants/* linksConstants.DATA_CATALOG_CONNECTORS */.s.DATA_CATALOG_CONNECTORS, "?data_source=Equifax")
            },
            {
                img: Sayari,
                name: "Sayari",
                url: "".concat(linksConstants/* linksConstants.DATA_CATALOG_CONNECTORS */.s.DATA_CATALOG_CONNECTORS, "?data_source=Sayari%20Labs")
            },
            {
                img: Seon_1,
                name: "Seon",
                url: "".concat(linksConstants/* linksConstants.DATA_CATALOG_CONNECTORS */.s.DATA_CATALOG_CONNECTORS, "?data_source=Seon")
            },
            {
                img: Ekata_1,
                name: "Ekata",
                url: "".concat(linksConstants/* linksConstants.DATA_CATALOG_CONNECTORS */.s.DATA_CATALOG_CONNECTORS, "?data_source=Ekata")
            },
            {
                img: Nomino,
                name: "Nomino",
                url: "".concat(linksConstants/* linksConstants.DATA_CATALOG_CONNECTORS */.s.DATA_CATALOG_CONNECTORS, "?data_source=Nomino%20Data")
            },
            {
                img: Acxiom,
                name: "Acxiom",
                url: "".concat(linksConstants/* linksConstants.DATA_CATALOG_CONNECTORS */.s.DATA_CATALOG_CONNECTORS, "?data_source=Acxiom")
            }, 
        ],
        insurance: [
            {
                img: Attom/* default */.Z,
                name: "Attom",
                url: "".concat(linksConstants/* linksConstants.DATA_CATALOG_CONNECTORS */.s.DATA_CATALOG_CONNECTORS, "?data_source=Attom")
            },
            {
                img: HazardHub,
                name: "HazardHub",
                url: "".concat(linksConstants/* linksConstants.DATA_CATALOG_CONNECTORS */.s.DATA_CATALOG_CONNECTORS, "?data_source=HazardHub")
            },
            {
                img: Equifax_1,
                name: "Equifax",
                url: "".concat(linksConstants/* linksConstants.DATA_CATALOG_CONNECTORS */.s.DATA_CATALOG_CONNECTORS, "?data_source=Equifax")
            },
            {
                img: Experian,
                name: "Experian",
                url: "".concat(linksConstants/* linksConstants.DATA_CATALOG_CONNECTORS */.s.DATA_CATALOG_CONNECTORS, "?data_source=Experian")
            },
            {
                img: Acxiom,
                name: "Acxiom",
                url: "".concat(linksConstants/* linksConstants.DATA_CATALOG_CONNECTORS */.s.DATA_CATALOG_CONNECTORS, "?data_source=Acxiom")
            },
            {
                img: DataAxle/* default */.Z,
                name: "Data Axle",
                url: "".concat(linksConstants/* linksConstants.DATA_CATALOG_CONNECTORS */.s.DATA_CATALOG_CONNECTORS, "?data_source=Data%20Axle")
            },
            {
                img: Infutor,
                name: "Infutor",
                url: "".concat(linksConstants/* linksConstants.DATA_CATALOG_CONNECTORS */.s.DATA_CATALOG_CONNECTORS, "?data_source=Infutor")
            },
            {
                img: PeopleDataLabs,
                name: "People Data Labs",
                url: "".concat(linksConstants/* linksConstants.DATA_CATALOG_CONNECTORS */.s.DATA_CATALOG_CONNECTORS, "?data_source=People%20Data%20Labs")
            }, 
        ]
    }
};
/* harmony default export */ var industryPages = (data);


/***/ }),

/***/ 9780:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "R": function() { return /* binding */ IndustryHero; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/landingPage/views/components/MainCtaButton.jsx
var MainCtaButton = __webpack_require__(11723);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/platform/utils/useViewport.js + 1 modules
var useViewport = __webpack_require__(72573);
;// CONCATENATED MODULE: ./src/landingPage/views/IndustryPages/components/IndustryHero/IndustryHeroImage.jsx




var IndustryHeroImage = function(param) {
    var id = param.id, img = param.img, alt = param.alt;
    var desktop_small_min = (0,useViewport/* useViewport */.S)().desktop_small_min;
    var deviceSpecificProps = desktop_small_min ? {
        width: 1066,
        height: 208,
        priority: true,
        src: img.desktop
    } : {
        width: 85,
        height: 532,
        src: img.mobile
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), (0,_object_spread/* default */.Z)({
        id: id,
        alt: alt
    }, deviceSpecificProps));
};

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
;// CONCATENATED MODULE: ./src/landingPage/views/IndustryPages/components/IndustryHero/IndustryHero.jsx





var IndustryHero = function(param) {
    var title = param.title, description = param.description, img = param.img, images = param.images, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: (0,clsx_m/* default */.Z)("industry_hero-background", className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "industry_hero",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "section-layout",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "industry_hero-text",
                        children: description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MainCtaButton/* MainCtaButton */.T, {
                        autoWidth: true,
                        "data-test-id": "industry_hero-button"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "industry_hero-main_image",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "industry_hero-images_container",
                            children: images.mainSection.map(function(param) {
                                var id = param.id, img = param.img, alt = param.alt;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IndustryHeroImage, {
                                    img: img,
                                    alt: alt
                                }, id);
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "home_hero-small_text ".concat(!img && "margin"),
                        children: "Join the customers already unlocking the power of external data with Demyst"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "industry_hero-providers",
                        children: images.footerSection.map(function(param) {
                            var id = param.id, img = param.img, alt = param.alt, width = param.width, height = param.height;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: img.src,
                                alt: alt,
                                width: width,
                                height: height,
                                priority: true
                            }, id);
                        })
                    })
                ]
            })
        })
    });
};


/***/ }),

/***/ 91097:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "B": function() { return /* binding */ IndustryMetrics; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
;// CONCATENATED MODULE: ./src/landingPage/views/IndustryPages/components/IndustryMetrics/MetricsItem.jsx

var MetricsItem = function(param) {
    var label = param.label, description = param.description;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "metrics-item",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "metrics-item-name",
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "metrics-item-description",
                children: description
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/landingPage/views/IndustryPages/components/IndustryMetrics/MetricsList.jsx




var MetricsList = function(param) {
    var metrics = param.metrics, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* default */.Z)("metrics", className),
        children: metrics.map(function(item) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(MetricsItem, (0,_object_spread/* default */.Z)({}, item), item.label);
        })
    });
};

;// CONCATENATED MODULE: ./src/landingPage/views/IndustryPages/components/IndustryMetrics/IndustryMetrics.jsx


var IndustryMetrics = function(param) {
    var metrics = param.metrics, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "industry_metrics-background",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "industry_metrics",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "section-layout rounded",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MetricsList, {
                        metrics: metrics,
                        className: ""
                    }),
                    children
                ]
            })
        })
    });
};


/***/ }),

/***/ 82634:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* binding */ IndustryRecipes; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/landingPage/assets/svg/components/RecipeArrow.svg
var RecipeArrow = __webpack_require__(73863);
;// CONCATENATED MODULE: ./src/landingPage/views/IndustryPages/components/IndustryRecipes/IndustryRecipe.jsx



var IndustryRecipe = /*#__PURE__*/ react.forwardRef(function(param, ref) {
    var title = param.title, type = param.type, url = param.url, description = param.description, ctaText = param.ctaText;
    var linkRef = (0,react.useRef)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
        ref: ref,
        className: "industry_recipe_article",
        "aria-hidden": "true",
        onClick: function() {
            return linkRef.current.click();
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "industry_recipe_article-pill",
                children: type
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                href: url,
                ref: linkRef,
                children: [
                    ctaText,
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: RecipeArrow/* default.src */.Z.src,
                        alt: "",
                        width: "16",
                        height: "16",
                        loading: "lazy"
                    })
                ]
            })
        ]
    });
});

;// CONCATENATED MODULE: ./src/landingPage/views/IndustryPages/components/IndustryRecipes/IndustryRecipes.jsx




var IndustryRecipes = function(param) {
    var recipes = param.recipes;
    var card = (0,react.useRef)(null);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "industry_recipes_section",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "industry_recipes_section-container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    children: "Recipes"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "Combine multiple data sources using templates pre-built by Demyst for getting started on common financial services problems."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "industry_recipes_section-grid",
                    children: recipes.map(function(item) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(IndustryRecipe, (0,_object_spread/* default */.Z)({
                            ref: card
                        }, item), item.title);
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 62211:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* binding */ TextSection; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/landingPage/views/IndustryPages/components/TextSection/TextCard.jsx

var TextCard = function(param) {
    var title = param.title, text1 = param.text1, text2 = param.text2, img = param.img;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "industry_text_content-card",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "industry_text_content-card-header",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "industry_text_content-card-section",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: img,
                        alt: "Check",
                        height: "24",
                        width: "24",
                        loading: "eager"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "industry_text_content-card-section-text",
                        children: text1
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "industry_text_content-card-section",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: img,
                        alt: "Check",
                        height: "24",
                        width: "24",
                        loading: "eager"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "industry_text_content-card-section-text",
                        children: text2
                    })
                ]
            })
        ]
    }, title);
};

;// CONCATENATED MODULE: ./src/landingPage/views/IndustryPages/components/TextSection/TextSection.jsx



var TextSection = function(param) {
    var textData = param.textData;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "industry_text_content-background",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "industry_text_content",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "section-layout",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "industry_text_content-container",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "industry_text_content-question",
                                children: "Is your external data spend continuing to rise?"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "industry_text_content-question",
                                children: "Are you dealing with the complexity of multiple point solutions and API’s?"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "industry_text_content-text",
                                children: "Leverage data across multiple sources such as Experian, Equifax, Transunion, Illion, and more, increasing your confidence and accuracy of decisions. Simplify your fraud stack complexity with a single platform for all of your external data needs."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "industry_text_content-cards_container",
                        children: textData.map(function(item) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextCard, (0,_object_spread/* default */.Z)({}, item), item.title);
                        })
                    })
                ]
            })
        })
    });
};


/***/ }),

/***/ 97065:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "R": function() { return /* binding */ DataProviders; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/landingPage/views/assets/logos/Attom.svg
var Attom = __webpack_require__(26063);
// EXTERNAL MODULE: ./src/landingPage/views/assets/logos/DataAxle.svg
var DataAxle = __webpack_require__(32863);
;// CONCATENATED MODULE: ./src/landingPage/views/assets/logos/Powerlytics.svg
/* harmony default export */ var Powerlytics = ({"src":"/_next/static/media/Powerlytics.677eec81.svg","height":48,"width":39});
;// CONCATENATED MODULE: ./src/landingPage/views/assets/logos/Quantarium.svg
/* harmony default export */ var Quantarium = ({"src":"/_next/static/media/Quantarium.2c829574.svg","height":60,"width":60});
;// CONCATENATED MODULE: ./src/landingPage/views/assets/logos/Seon.svg
/* harmony default export */ var Seon = ({"src":"/_next/static/media/Seon.dacab356.svg","height":60,"width":60});
;// CONCATENATED MODULE: ./src/landingPage/views/assets/logos/Telesign.svg
/* harmony default export */ var Telesign = ({"src":"/_next/static/media/Telesign.89f572c3.svg","height":60,"width":60});
;// CONCATENATED MODULE: ./src/landingPage/views/assets/logos/Equifax.svg
/* harmony default export */ var Equifax = ({"src":"/_next/static/media/Equifax.0f97663b.svg","height":60,"width":60});
;// CONCATENATED MODULE: ./src/landingPage/views/assets/logos/Ekata.svg
/* harmony default export */ var Ekata = ({"src":"/_next/static/media/Ekata.ada69be5.svg","height":60,"width":60});
// EXTERNAL MODULE: ./src/landingPage/views/components/LinkButton.jsx
var LinkButton = __webpack_require__(84135);
// EXTERNAL MODULE: ./src/constants/linksConstants.js
var linksConstants = __webpack_require__(71571);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/landingPage/views/components/sections/DataProviders.jsx












var localProviders = [
    {
        img: Attom/* default */.Z,
        name: "Attom",
        url: "".concat(linksConstants/* linksConstants.DATA_CATALOG_CONNECTORS */.s.DATA_CATALOG_CONNECTORS, "?data_source=Attom")
    },
    {
        img: DataAxle/* default */.Z,
        name: "Data Axle",
        url: "".concat(linksConstants/* linksConstants.DATA_CATALOG_CONNECTORS */.s.DATA_CATALOG_CONNECTORS, "?data_source=Data Axle")
    },
    {
        img: Powerlytics,
        name: "Powerlytics",
        url: "".concat(linksConstants/* linksConstants.DATA_CATALOG_CONNECTORS */.s.DATA_CATALOG_CONNECTORS, "?data_source=Powerlytics")
    },
    {
        img: Quantarium,
        name: "Quantarium",
        url: "".concat(linksConstants/* linksConstants.DATA_CATALOG_CONNECTORS */.s.DATA_CATALOG_CONNECTORS, "?data_source=Quantarium")
    },
    {
        img: Seon,
        name: "Seon",
        url: "".concat(linksConstants/* linksConstants.DATA_CATALOG_CONNECTORS */.s.DATA_CATALOG_CONNECTORS, "?data_source=Seon")
    },
    {
        img: Telesign,
        name: "Telesign",
        url: "".concat(linksConstants/* linksConstants.DATA_CATALOG_CONNECTORS */.s.DATA_CATALOG_CONNECTORS, "?data_source=Telesign")
    },
    {
        img: Equifax,
        name: "Equifax",
        url: "".concat(linksConstants/* linksConstants.DATA_CATALOG_CONNECTORS */.s.DATA_CATALOG_CONNECTORS, "?data_source=Equifax")
    },
    {
        img: Ekata,
        name: "Ekata",
        url: "".concat(linksConstants/* linksConstants.DATA_CATALOG_CONNECTORS */.s.DATA_CATALOG_CONNECTORS, "?data_source=Ekata")
    }, 
];
var DataProviders = function(param) {
    var _providers = param.providers, providers = _providers === void 0 ? localProviders : _providers;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "home_data_providers-background",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "home_data_providers",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "section-layout",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        children: "Access hundreds of data providers from a single API"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "home_data_providers-text",
                        children: "Demyst provides seamless access to the most valuable data across the globe about Businesses, People, Property and Automotive, for Financial Services, Insurance, Buy Now Pay Later, and more. Here are just a few examples from our wide-ranging connector:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "home_data_providers-grid",
                        children: providers.map(function(param) {
                            var img = param.img, name = param.name, url = param.url;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: url,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "home_data_providers-card",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "img-container",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: img.src,
                                                alt: "",
                                                loading: "lazy",
                                                width: "80",
                                                height: "80"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            children: name
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "home_data_providers-card-btndummy",
                                            children: "View in Catalog"
                                        })
                                    ]
                                }, name)
                            }, name);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "home_data_providers-banner",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Browse hundreds of data providers"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkButton/* LinkButton */.Q, {
                                variant: "inverted",
                                href: linksConstants/* linksConstants.DATA_CATALOG_HOME */.s.DATA_CATALOG_HOME,
                                children: "View Connectors"
                            })
                        ]
                    })
                ]
            })
        })
    });
};


/***/ }),

/***/ 3296:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "q": function() { return /* binding */ Solutions; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/landingPage/views/components/sections/assets/icons/Solution0.svg
/* harmony default export */ var Solution0 = ({"src":"/_next/static/media/Solution0.194608aa.svg","height":49,"width":49});
;// CONCATENATED MODULE: ./src/landingPage/views/components/sections/assets/icons/Solution1.svg
/* harmony default export */ var Solution1 = ({"src":"/_next/static/media/Solution1.0d8a06f9.svg","height":49,"width":49});
;// CONCATENATED MODULE: ./src/landingPage/views/components/sections/assets/icons/Solution2.svg
/* harmony default export */ var Solution2 = ({"src":"/_next/static/media/Solution2.65671ea6.svg","height":49,"width":49});
;// CONCATENATED MODULE: ./src/landingPage/views/components/sections/assets/icons/Solution3.svg
/* harmony default export */ var Solution3 = ({"src":"/_next/static/media/Solution3.b5684284.svg","height":49,"width":49});
;// CONCATENATED MODULE: ./src/landingPage/views/components/sections/assets/icons/Solution4.svg
/* harmony default export */ var Solution4 = ({"src":"/_next/static/media/Solution4.da0d21f9.svg","height":49,"width":49});
;// CONCATENATED MODULE: ./src/landingPage/views/components/sections/assets/icons/Solution5.svg
/* harmony default export */ var Solution5 = ({"src":"/_next/static/media/Solution5.6ced0d00.svg","height":49,"width":49});
;// CONCATENATED MODULE: ./src/landingPage/views/components/sections/assets/icons/Solution6.svg
/* harmony default export */ var Solution6 = ({"src":"/_next/static/media/Solution6.0edbd0d8.svg","height":49,"width":49});
;// CONCATENATED MODULE: ./src/landingPage/views/components/sections/assets/icons/Solution7.svg
/* harmony default export */ var Solution7 = ({"src":"/_next/static/media/Solution7.00749a4f.svg","height":49,"width":49});
// EXTERNAL MODULE: ./src/constants/linksConstants.js
var linksConstants = __webpack_require__(71571);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/landingPage/views/components/sections/Solutions.jsx











var solutions = [
    {
        img: Solution0,
        name: "KYB Compliance",
        description: "Conduct due diligence checks on businesses.",
        url: linksConstants/* linksConstants.USECASE_KYB */.s.USECASE_KYB
    },
    {
        img: Solution1,
        name: "KYC Compliance",
        description: "Onboard customers subject to AML regulations.",
        url: linksConstants/* linksConstants.USECASE_KYC */.s.USECASE_KYC
    },
    {
        img: Solution2,
        name: "Application Prefill",
        description: "Populate key fields using minimal inputs.",
        url: linksConstants/* linksConstants.USECASE_PREFILL */.s.USECASE_PREFILL
    },
    {
        img: Solution3,
        name: "Business Risk Assessment",
        description: "Access business financials and credit signals.",
        url: linksConstants/* linksConstants.USECASE_BUSINESS_ONBOARDING */.s.USECASE_BUSINESS_ONBOARDING
    },
    {
        img: Solution4,
        name: "Contact Data Enrichment",
        description: "Enhance customer lists across key fields.",
        url: linksConstants/* linksConstants.USECASE_DATA_ENRICHMENT */.s.USECASE_DATA_ENRICHMENT
    },
    {
        img: Solution5,
        name: "Credit Bureau  Integration",
        description: "Integrate with credit bureaus globally.",
        url: linksConstants/* linksConstants.USECASE_CREDIT_BUREAU */.s.USECASE_CREDIT_BUREAU
    },
    {
        img: Solution6,
        name: "Portfolio Monitoring",
        description: "Identify customer engagement opportunities.",
        url: linksConstants/* linksConstants.USECASE_PORTFOLIO_MONITORING */.s.USECASE_PORTFOLIO_MONITORING
    },
    {
        img: Solution7,
        name: "Lead Targeting",
        description: "Generate, enrich, and prioritize customer lists.",
        url: linksConstants/* linksConstants.USECASE_LEAD_TARGETING */.s.USECASE_LEAD_TARGETING
    }, 
];
var Solutions = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "home_solutions-background",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "home_solutions",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "section-layout",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        children: "Access the world’s best data for your use case"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "home_solutions-text",
                        children: "Demyst addresses business challenges with its platform powered by a certified external data ecosystem and a single, global API. The platform enables custom solutions on the fly based on changing workflow requirements. Some common examples:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "home_solutions-grid",
                        children: solutions.map(function(param) {
                            var img = param.img, name = param.name, description = param.description, url = param.url;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: url,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "home_solutions-card",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: img.src,
                                            alt: "",
                                            width: "48",
                                            height: "48",
                                            loading: "lazy"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "home_solutions-card_text",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    children: name
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: description
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "home_solutions-card-btndummy",
                                                    children: "Learn More"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }, name);
                        })
                    })
                ]
            })
        })
    });
};


/***/ }),

/***/ 72573:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* binding */ useViewport; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/platform/utils/useMediaQuery.js

/**
 * This hook is a kind of React wrapper over `window.matchMedia` functionality. It receives media
 * query as a parameter and determines if the document matches that query. It also monitors changes
 * in document so it will change the returned value if needed.
 * @param query
 * @returns {boolean}
 */ function useMediaQuery(query) {
    var ref = (0,react.useState)(false), matches = ref[0], setMatches = ref[1];
    (0,react.useEffect)(function() {
        var media = window.matchMedia(query);
        if (media.matches !== matches) {
            setMatches(media.matches);
        }
        var listener = function() {
            setMatches(media.matches);
        };
        // older browsers don't have support for`addEventListener` in matchMedia and have to use
        // older "addListener" function
        if (media && media.addEventListener) {
            media.addEventListener("change", listener);
        } else {
            media.addListener(listener);
        }
        return function() {
            if (media && media.removeEventListener) {
                media.removeEventListener("change", listener);
            } else {
                media.removeListener(listener);
            }
        };
    }, [
        matches,
        query
    ]);
    return matches;
}

;// CONCATENATED MODULE: ./src/platform/utils/useViewport.js

var useViewport = function() {
    var desktop_small_min = useMediaQuery("(min-width: 64.001rem)");
    var desktop_min = useMediaQuery("(min-width: 70.001rem)");
    var desktop = useMediaQuery("(max-width: 90rem)");
    var desktop_small = useMediaQuery("(max-width: 70rem)");
    var tablet_landscape = useMediaQuery("(max-width: 64rem)");
    var tablet = useMediaQuery("(max-width: 48rem)");
    var mobile = useMediaQuery("(max-width: 30rem)");
    return {
        desktop_small_min: desktop_small_min,
        desktop_min: desktop_min,
        desktop: desktop,
        desktop_small: desktop_small,
        tablet_landscape: tablet_landscape,
        tablet: tablet,
        mobile: mobile
    };
};


/***/ })

}]);